import React, { useEffect, useState } from 'react'

import { useLazyQuery } from '@apollo/react-hooks'
import { AUTOCOMPLETE, GET_PLACE_DETAILS } from 'operations/Location'

import { nanoid } from 'nanoid'

import './search.scss'
// import { Input } from 'components/Form'
import Toggle from 'components/Toggle'
import { camelCase } from 'lodash'
import { Dark,  Light } from 'components/Theme'

export default function Search({ filters, onChange, onSetGeometry, onChangeFilter, provinceCode, clearProvinceCode, theme, changeTheme }) {

    const [ term, setTerm ] = useState('')

    const [ advancedSearchExpanded, setAdvancedSearchExpanded ] = useState(false)
    // const [ filtersExpanded, setFiltersExpanded ] = useState(false)

    const [ autocompleteSession, setAutocompleteSession ] = useState(() => nanoid())

    const [ autocomplete, { data } ] = useLazyQuery(AUTOCOMPLETE)
    const [ getPlaceDetails, { data: placeDetailData } ] = useLazyQuery(GET_PLACE_DETAILS)

    const [ place, setPlace ] = useState()

    useEffect(() => {
        if (term.length > 1) {
            autocomplete({ variables: { term: term.trim(), session: autocompleteSession, provinceCode } })
        }
    }, [autocomplete, term, autocompleteSession, provinceCode])

    useEffect(() => {
        if (placeDetailData && place) {
            onSetGeometry && onSetGeometry({ ...placeDetailData.placeDetails.geometry, place, autocompleteSession })
            setPlace()
        }
        // eslint-disable-next-line
    }, [placeDetailData, onSetGeometry])

    return (
        <div className='search__container'>
            <button type='button' className='selectedTheme' onClick={ changeTheme }>{ theme === 'dark' ? <Dark/>: <Light/> }</button>
            <div className='inputContainer inputContainer--search'>
                <label htmlFor='search'>
                    <i className="material-icons location">location_on</i>
                    <input inputMode='search' id="search" type='text' placeholder={`Search parts stores, service providers, dealerships and more`} value={ term } onChange={(e) => setTerm(e.target.value)} />
                    {/* <button type='button' className='searchButton' onClick={ () => setFiltersExpanded(!filtersExpanded) }><i className='material-icons'>filter_list</i></button> */}
                    <button type='button' className={`searchButton ${ advancedSearchExpanded ? 'searchButton--expanded' : '' }`} onClick={ () => setAdvancedSearchExpanded(!advancedSearchExpanded) }><i className='material-icons'>keyboard_arrow_down</i></button>
                </label>
                {
                    data && data.search && (
                        <div className='autocompleteResults'>
                            {
                                term.length > 1 && data && data.search && data.search.results && data.search.results.map((result) => {
                                    return (
                                        <div key={ result.id } className='autocomplete__result' onClick={() => {
                                                setTerm('')
                                                onChange && onChange(result.id) 
                                            }}>
                                            <strong dangerouslySetInnerHTML={{ __html: result.companyName }}/>
                                            <div><span dangerouslySetInnerHTML={{ __html: result.address }} />, <span dangerouslySetInnerHTML={{ __html: result.city }} />, <span dangerouslySetInnerHTML={{ __html: result.province }} /> <span dangerouslySetInnerHTML={{ __html: result.postal }} /></div>
                                        </div>
                                    )
                                })
                            }

                            {
                                term.length > 1 && data && data.addressAutocomplete && data.addressAutocomplete.results && data.addressAutocomplete.results.map((result) => {

                                    // let formattedDescription = result.description

                                    // result.matched_substrings.map(matched_substring => {
                                    //     return formattedDescription = formattedDescription.slice(0, matched_substring.offset) + '<strong>' + formattedDescription.slice(matched_substring.offset, matched_substring.length) + '</strong>' + formattedDescription.slice(matched_substring.offset + matched_substring.length)
                                    // })
                                    // console.log(formattedDescription)
                                    return (
                                        <div key={ result.place_id } className='autocomplete__result' onClick={ async () => {
                                            
                                            getPlaceDetails({
                                                variables: {
                                                    placeId: result.place_id,
                                                    session: autocompleteSession
                                                }
                                            })
                                            setAutocompleteSession(nanoid())
                                            setTerm('')
                                            setPlace(result)
                                                // onChange && onChange(result.id) 
                                            }}>
                                                <span dangerouslySetInnerHTML={{ __html: result.description }} />
                                        </div>
                                    )
                                })
                            }
                        </div>
                    )
                }
            </div>
            <div className={`searchDropdown__container ${ advancedSearchExpanded ? 'searchDropdown__container--expanded' : '' }`}>
                <div className='searchDropdown'>
                    <div className='locationFilters'>
                        {
                            filters && Object.keys(filters).map((filterKey) => (
                                <div key={filterKey} className='locationFilter'><Toggle name={filterKey} className={camelCase(filterKey)} on={ filters[filterKey].isVisible } onChange={(state) => onChangeFilter({ key: filterKey, state })}/>{ filterKey }</div>
                            ))
                        }
                    </div>
                    {/* <div className='searchParams'>
                        <Input label='Search term' />
                        <Input label='Address' />
                        <Input label='City' />
                        <Input label='Province' />
                    </div> */}
                </div>
            </div>
            <button type='button' className='selectedRegion' onClick={ clearProvinceCode }>{ provinceCode }</button>
        </div>
    )

}